import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	videoModalTitle: {
		id: 'rovo-video-modal.video-modal-title',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Get Started with Rovo!',
		description: 'Title for the video modal',
	},
});
